import I18n from 'I18n';
import SettingsSidebar from 'automation-ui-canvas/containers/settings/v2/SettingsSidebar';
export const SettingsOption = {
  id: 'settings',
  getLabel: () => I18n.text('automation.editorMenuBar.menus.settings'),
  ModalComponent: SettingsSidebar,
  shortcut: {
    key: ',',
    control: true
  }
};